import { Share2, Copy, Check } from "lucide-react";
import { useState } from "react";
import { GlassPanel } from "@/components/ui/glass-panel";

interface WeatherShareProps {
  location: string;
  temp: number;
  description: string;
}

export function WeatherShare({ location, temp, description }: WeatherShareProps) {
  const [copied, setCopied] = useState(false);

  const shareText = `Weather in ${location}: ${Math.round(temp)}°C, ${description.charAt(0).toUpperCase() + description.slice(1)} — via Vertali Weather`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
      const textarea = document.createElement("textarea");
      textarea.value = shareText;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Weather in ${location}`,
          text: shareText,
          url: window.location.origin,
        });
      } catch {}
    } else {
      handleCopy();
    }
  };

  return (
    <button
      onClick={handleShare}
      className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
      title="Share weather"
    >
      {copied ? (
        <>
          <Check className="h-3 w-3 text-emerald-400" />
          <span className="text-emerald-400">Copied!</span>
        </>
      ) : (
        <>
          <Share2 className="h-3 w-3" />
          <span>Share</span>
        </>
      )}
    </button>
  );
}